import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// Aura con la marca Hexxa: el primary de Aura es verde (emerald) y dejaba botones, focos y
// checkboxes de PrimeNG fuera de marca frente al azul del resto de la UI (#1e6fc8, --sc-accent).
// Radios un paso más suaves que Aura (6px → 10px en controles, 12px → 14px en diálogos), en
// línea con lo que ya usan las pantallas hechas a mano. Todo lo que no es PrimeNG lo toma de
// las variables --hx-* de styles.scss.
export const HexxaPreset = definePreset(Aura, {
  primitive: {
    borderRadius: { none: '0', xs: '4px', sm: '6px', md: '10px', lg: '14px', xl: '16px' },
  },
  semantic: {
    primary: {
      50: '#f4f8fc', 100: '#c9dcf2', 200: '#9ec1e7', 300: '#74a6dd', 400: '#498ad2',
      500: '#1e6fc8', 600: '#1a5eaa', 700: '#154e8c', 800: '#113d6e', 900: '#0c2c50', 950: '#081c32',
    },
    formField: { borderRadius: '{border.radius.md}' },
    content:   { borderRadius: '{border.radius.md}' },
    overlay: {
      select:  { borderRadius: '{border.radius.md}', shadow: '0 8px 32px rgba(13,27,46,.16)' },
      popover: { borderRadius: '{border.radius.md}', shadow: '0 8px 32px rgba(13,27,46,.16)' },
      modal:   { borderRadius: '{border.radius.lg}' },
    },
  },
  components: {
    tag:  { root: { borderRadius: '999px' } },
    card: { root: { borderRadius: '{border.radius.lg}', shadow: '0 1px 3px rgba(13,27,46,.05), 0 6px 16px rgba(13,27,46,.04)' } },
  },
});
